import React, { Component } from 'react'

export class AsSwitch extends Component {
  constructor(props) {
    super(props);
    this.ref = React.createRef();
  }

  componentDidMount() {
    this.ref.current.addEventListener('change', this._onChanged.bind(this));
  }

  _onChanged(event) {
    const { onChanged } = this.props;
    onChanged && onChanged(event);
  }

  render() {
    return (
      <as-switch ref={this.ref} {...this.props}></as-switch>
    )
  }
}

export default AsSwitch
